export default __webpack_public_path__ + "static/jandj-503188bef8bc2c261cd5880899bbbe6e.jpg";